var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.piiAuthorized
        ? _c(
            "el-button",
            {
              staticClass: "nav-action",
              staticStyle: { padding: "10px 25px" },
              attrs: { type: "primary", round: "" },
              on: {
                click: function ($event) {
                  return _vm.openDialog()
                },
              },
            },
            [_vm._v("\n    PLC Request\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            fullscreen: true,
            height: "100%",
            width: "100%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "header-item" }, [
                    _vm._v("Devices"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value:
                        _vm.loading.status &&
                        [null, "devices"].includes(_vm.loading.entity),
                      expression:
                        "loading.status && [null, 'devices'].includes(loading.entity)",
                    },
                  ],
                  ref: "filterTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableDevices },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "kind",
                      label: "Kinds",
                      filters: _vm.typeOfDevices,
                      "filter-method": _vm.filterTypeOfDevice,
                      sortable: "",
                      width: "250",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.startCase(scope.row.kind)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "market", label: "Market", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.getLocationMarket(scope.row)
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "Name",
                      filters: _vm.deviceNames,
                      "filter-method": _vm.filterDeviceName,
                      sortable: "",
                      width: "400",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.startCase(scope.row.description)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.delayedFulfillmentEnabled
                    ? _c("el-table-column", {
                        attrs: { label: "Fulfillment", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.http.coverage.device.fetching &&
                                  !_vm.loading.status
                                    ? _c("i", {
                                        staticClass: "el-icon-loading",
                                      })
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "bottom",
                                                trigger: "hover",
                                                disabled:
                                                  !_vm.showFulfillmentReason(
                                                    scope.row.eligibility
                                                      .isDelayedFulfillment
                                                  ),
                                              },
                                            },
                                            [
                                              _c(
                                                "el-tag",
                                                {
                                                  style: {
                                                    cursor: scope.row
                                                      .eligibility
                                                      .isDelayedFulfillment
                                                      ? "help"
                                                      : "default",
                                                  },
                                                  attrs: {
                                                    slot: "reference",
                                                    type: _vm.fulfillmentTagType(
                                                      scope.row.eligibility
                                                        .isDelayedFulfillment
                                                    ),
                                                    size: "mini",
                                                  },
                                                  slot: "reference",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.getFulfillmentStatus(
                                                          scope.row.eligibility
                                                            .isDelayedFulfillment
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("FulfillmentReasons", {
                                                attrs: {
                                                  reason: _vm.get(
                                                    scope.row,
                                                    "eligibility.delayedFulfillmentReason",
                                                    ""
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2912490773
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "warranty_status",
                      label: "Warranty Status",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.http.coverage.device.fetching &&
                            !_vm.loading.status
                              ? _c("i", { staticClass: "el-icon-loading" })
                              : _c(
                                  "div",
                                  [
                                    _vm.http.coverage.device.loaded &&
                                    !!scope.row.warranty
                                      ? _c(
                                          "el-popover",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "300px",
                                            },
                                            attrs: {
                                              placement: "bottom",
                                              trigger: "hover",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticStyle: { cursor: "help" },
                                                attrs: {
                                                  slot: "reference",
                                                  type: _vm.warrantyTagType(
                                                    scope.row
                                                  ),
                                                  size: "mini",
                                                },
                                                slot: "reference",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.get(
                                                        scope.row.warranty,
                                                        "status",
                                                        "Not Available"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("WarrantyInfo", {
                                              attrs: {
                                                data: scope.row.warranty,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          {
                                            style: {
                                              color: _vm.colors.outOfWarranty,
                                            },
                                          },
                                          [_vm._v("Not Available")]
                                        ),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Eligibility", width: "170" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.http.coverage.device.fetching &&
                            !_vm.loading.status
                              ? _c("i", { staticClass: "el-icon-loading" })
                              : _c(
                                  "div",
                                  [
                                    [
                                      _c("EligibilityTags", {
                                        attrs: {
                                          eligibility: scope.row.eligibility,
                                        },
                                      }),
                                    ],
                                  ],
                                  2
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "device_id",
                      label: "Device Id",
                      width: "170",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "state",
                      label: "state",
                      filters: _vm.deviceState,
                      "filter-method": _vm.filterDeviceState,
                      width: "100",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.startCase(scope.row.state)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { width: "360", label: "Request" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              [
                                _c("WithVariable", {
                                  staticClass: "inline",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var repl = ref.repl
                                          if (repl === void 0)
                                            repl =
                                              scope.row.eligibility.replacement
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  disabled:
                                                    !!repl.isUserAllowed &&
                                                    !repl.noBypassable,
                                                  content:
                                                    _vm.serviceTooltip(repl),
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "acl",
                                                        rawName: "v-acl.show",
                                                        value: {
                                                          permission: "create",
                                                          on: "ReplaceRequest",
                                                        },
                                                        expression:
                                                          "{ permission: 'create', on: 'ReplaceRequest' }",
                                                        modifiers: {
                                                          show: true,
                                                        },
                                                      },
                                                    ],
                                                    class: {
                                                      disabled:
                                                        !repl.isUserAllowed ||
                                                        repl.noBypassable,
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      round: "",
                                                      disabled:
                                                        !repl.isUserAllowed ||
                                                        repl.noBypassable,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.replaceForm(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Replace\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("WithVariable", {
                                  staticClass: "inline",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var refund = ref.refund
                                          if (refund === void 0)
                                            refund =
                                              scope.row.eligibility.refund
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  disabled:
                                                    !!refund.isUserAllowed &&
                                                    !refund.noBypassable,
                                                  content:
                                                    _vm.serviceTooltip(refund),
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "acl",
                                                        rawName: "v-acl.show",
                                                        value: {
                                                          permission: "create",
                                                          on: "RefundRequest",
                                                        },
                                                        expression:
                                                          "{ permission: 'create', on: 'RefundRequest' }",
                                                        modifiers: {
                                                          show: true,
                                                        },
                                                      },
                                                    ],
                                                    class: {
                                                      disabled:
                                                        !refund.isUserAllowed ||
                                                        refund.noBypassable,
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      round: "",
                                                      disabled:
                                                        !refund.isUserAllowed ||
                                                        refund.noBypassable,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.refundForm(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Refund\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("WithVariable", {
                                  staticClass: "inline",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var parts = ref.parts
                                          if (parts === void 0)
                                            parts = scope.row.eligibility.parts
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  disabled:
                                                    !!parts.isUserAllowed &&
                                                    !parts.noBypassable,
                                                  content:
                                                    _vm.serviceTooltip(parts),
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "acl",
                                                        rawName: "v-acl.show",
                                                        value: {
                                                          permission: "create",
                                                          on: "PartsRequest",
                                                        },
                                                        expression:
                                                          "{ permission: 'create', on: 'PartsRequest' }",
                                                        modifiers: {
                                                          show: true,
                                                        },
                                                      },
                                                    ],
                                                    class: {
                                                      disabled:
                                                        !parts.isUserAllowed ||
                                                        parts.noBypassable,
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      round: "",
                                                      disabled:
                                                        !parts.isUserAllowed ||
                                                        parts.noBypassable,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.partsForm(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Parts\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-activity-table__footer-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      layout: "total, prev, pager, next",
                      "current-page": _vm.currentDevicePage,
                      "page-size": _vm.pageSize,
                      total: _vm.totalDevices,
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.currentDevicePage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.currentDevicePage = $event
                      },
                      "current-change": _vm.updateDisplayedDevices,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "header-item" }, [
                    _vm._v("Accessories"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value:
                        _vm.loading.status &&
                        [null, "accessories"].includes(_vm.loading.entity),
                      expression:
                        "loading.status && [null, 'accessories'].includes(loading.entity)",
                    },
                  ],
                  ref: "filterTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableAccessories },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "kind",
                      label: "Kind",
                      filters: _vm.typeOfAccessories,
                      "filter-method": _vm.filterTypeOfDevice,
                      sortable: "",
                      width: "250",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.startCase(scope.row.kind)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "market", label: "Market", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.getLocationMarket(scope.row)
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "Name",
                      filters: _vm.accessoryNames,
                      "filter-method": _vm.filterDeviceName,
                      sortable: "",
                      width: "400",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.startCase(scope.row.name)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Eligibility", width: "170" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.http.coverage.accessory.fetching &&
                            !_vm.loading.status
                              ? _c("i", { staticClass: "el-icon-loading" })
                              : _c(
                                  "div",
                                  [
                                    [
                                      _c("EligibilityTags", {
                                        attrs: {
                                          eligibility: scope.row.eligibility,
                                        },
                                      }),
                                    ],
                                  ],
                                  2
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "device_id",
                      label: "Device Id",
                      width: "170",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "state",
                      label: "state",
                      filters: _vm.accessoryStates,
                      "filter-method": _vm.filterDeviceState,
                      width: "100",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.startCase(scope.row.state)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { width: "360", label: "Request" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              [
                                _c("WithVariable", {
                                  staticClass: "inline",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var repl = ref.repl
                                          if (repl === void 0)
                                            repl =
                                              scope.row.eligibility.replacement
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  disabled:
                                                    !!repl.isUserAllowed &&
                                                    !repl.noBypassable,
                                                  content:
                                                    _vm.serviceTooltip(repl),
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "acl",
                                                        rawName: "v-acl.show",
                                                        value: {
                                                          permission: "create",
                                                          on: "ReplaceRequest",
                                                        },
                                                        expression:
                                                          "{ permission: 'create', on: 'ReplaceRequest' }",
                                                        modifiers: {
                                                          show: true,
                                                        },
                                                      },
                                                    ],
                                                    class: {
                                                      disabled:
                                                        !repl.isUserAllowed ||
                                                        repl.noBypassable,
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      round: "",
                                                      disabled:
                                                        !repl.isUserAllowed ||
                                                        repl.noBypassable,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.replaceForm(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Replace\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("WithVariable", {
                                  staticClass: "inline",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var refund = ref.refund
                                          if (refund === void 0)
                                            refund =
                                              scope.row.eligibility.refund
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  disabled:
                                                    !!refund.isUserAllowed &&
                                                    !refund.noBypassable,
                                                  content:
                                                    _vm.serviceTooltip(refund),
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "acl",
                                                        rawName: "v-acl.show",
                                                        value: {
                                                          permission: "create",
                                                          on: "RefundRequest",
                                                        },
                                                        expression:
                                                          "{ permission: 'create', on: 'RefundRequest' }",
                                                        modifiers: {
                                                          show: true,
                                                        },
                                                      },
                                                    ],
                                                    class: {
                                                      disabled:
                                                        !refund.isUserAllowed ||
                                                        refund.noBypassable,
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      round: "",
                                                      disabled:
                                                        !refund.isUserAllowed ||
                                                        refund.noBypassable,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.refundForm(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Refund\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("WithVariable", {
                                  staticClass: "inline",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var parts = ref.parts
                                          if (parts === void 0)
                                            parts = scope.row.eligibility.parts
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  disabled:
                                                    !!parts.isUserAllowed &&
                                                    !parts.noBypassable,
                                                  content:
                                                    _vm.serviceTooltip(parts),
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "acl",
                                                        rawName: "v-acl.show",
                                                        value: {
                                                          permission: "create",
                                                          on: "PartsRequest",
                                                        },
                                                        expression:
                                                          "{ permission: 'create', on: 'PartsRequest' }",
                                                        modifiers: {
                                                          show: true,
                                                        },
                                                      },
                                                    ],
                                                    class: {
                                                      disabled:
                                                        !parts.isUserAllowed ||
                                                        parts.noBypassable,
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      round: "",
                                                      disabled:
                                                        !parts.isUserAllowed ||
                                                        parts.noBypassable,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.partsForm(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Parts\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-activity-table__footer-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      layout: "total, prev, pager, next",
                      "current-page": _vm.currentAccessoriesPage,
                      "page-size": _vm.pageSize,
                      total: _vm.totalAccessories,
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.currentAccessoriesPage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.currentAccessoriesPage = $event
                      },
                      "current-change": _vm.updateDisplayedAccessories,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentDevice && _vm.replacementFormVisible
        ? _c("replacement-form", {
            ref: "replacement",
            attrs: {
              visible: _vm.replacementFormVisible,
              device: _vm.currentDevice,
              eligibility: _vm.currentDevice.eligibility,
              "is-supervisor": _vm.isSupervisor,
            },
            on: {
              "update:visible": function ($event) {
                _vm.replacementFormVisible = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentDevice
        ? _c("replacement-modal-form", {
            ref: "replacement",
            attrs: { device: _vm.currentDevice },
            on: {
              "closed-form": function ($event) {
                _vm.currentDevice = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentDevice
        ? _c("parts-modal-form", {
            ref: "parts",
            attrs: { device: _vm.currentDevice },
            on: {
              "closed-form": function ($event) {
                _vm.currentDevice = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentDevice
        ? _c("refund-modal-form", {
            ref: "refund",
            attrs: { device: _vm.currentDevice },
            on: {
              "closed-form": function ($event) {
                _vm.currentDevice = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("out-of-warranty-warning-modal", {
        ref: "outOfWarrantyWarningModal",
        on: {
          "on-close": function ($event) {
            _vm.currentDevice = null
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }